// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'polaris';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M8.784 1.728c0 4.68 2.304 7.416 7.488 7.488-4.824 0-7.272 2.592-7.488 7.488-.072-4.608-2.088-7.488-7.488-7.488 4.824 0 7.488-2.376 7.488-7.488zm6.192 0v3.024M13.464 3.24h3.024M3.672 13.248v3.024m-1.44-1.512h2.952'
  />
);

export const viewBox = '0 0 18 18';
